import {Component, ElementRef, OnInit} from '@angular/core';
import {Subject, timer} from 'rxjs';
import {AdminPanelService} from '../../data/admin-panel.service';
import {debounceTime} from 'rxjs/operators';
import {PricingGrade} from '../../../project-calc/data/pricing-grade';

@Component({
  selector: 'app-grade-editor',
  templateUrl: './grade-editor.component.html',
  styleUrls: ['./grade-editor.component.scss']
})
export class GradeEditorComponent implements OnInit {
  grades: PricingGrade[]

  loadingSpinner = true;

  updateItemsSubj = new Subject<number>()

  constructor(
    protected el: ElementRef,
    protected adminPanelService: AdminPanelService
  ) {
  }

  ngOnInit(): void {
    this.adminPanelService.getGrades().subscribe(grades => {
      this.grades = grades
      this.loadingSpinner = false
    })

    this.updateItemsSubj.pipe(debounceTime(500)).subscribe(index => {
      this.adminPanelService.updateGrade(this.grades[index]).subscribe(() => {

      })
    })
  }

  changesMade(index: number) {
    this.updateItemsSubj.next(index)
  }

  startEdit() {
    const tempInputs = (this.el.nativeElement as HTMLInputElement).getElementsByClassName('material-input-text');
    if (tempInputs) {
      timer(1).subscribe(() => {
        const lastInput = tempInputs[0] as HTMLInputElement
        lastInput.focus()
        lastInput.setSelectionRange(0, lastInput.value.length);
      })
    }
  }

  onEditComplete(event, index) {
    this.updateItemsSubj.next(index)
  }

  makeDefault(grade: PricingGrade, index: number) {
    this.grades.forEach((ggrade, iindex) => {
      if (ggrade.type === grade.type) {
        ggrade.isDefault = false;
      }
    })

    grade.isDefault = true;

    this.updateItemsSubj.next(index)
  }
}
